export interface IPatientInvitations {
    email: string,
    language: string,
    firstName: string,
    lastName: string
    healthcareProfessional?: string,
    therapeuticIndicationId?: number,
    healthcareFacilityId: number,
    isAnonymizedMode?: boolean,
    fileNumber?: string,
    carePlanTemplateId?: number,
    eventDate?: string
}

export class PatientInvitations {
    public email: string;
    public language: string;
    public firstName: string;
    public lastName: string;
    public healthcareProfessional?: string;
    public therapeuticIndicationId?: number;
    public healthcareFacilityId: number;
    public isAnonymizedMode?: boolean;
    public fileNumber?: string;
    public carePlanTemplateId?: number;
    public eventDate?: string;

    constructor(input: PatientInvitations) {
        this.email = input.email;
        this.language = input.language;
        this.firstName = input.firstName;
        this.lastName = input.lastName;
        this.healthcareProfessional = input.healthcareProfessional;
        this.therapeuticIndicationId = input.therapeuticIndicationId;
        this.healthcareFacilityId = input.healthcareFacilityId;
        this.isAnonymizedMode = input.isAnonymizedMode;
        this.fileNumber = input.fileNumber;
        this.carePlanTemplateId = input.carePlanTemplateId;
        this.eventDate = input.eventDate;
    }
}

export interface IHealthcareFacilityForm {
    firstName: string;
    lastName: string;
    email: string;
    preferredLanguage: string;
}
